"use strict";
exports.__esModule = true;
var react_1 = require("react");
exports.SocketIOContext = react_1.createContext(undefined);
//# sourceMappingURL=context.js.map